import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId, shortHandDate } from '../../../utility/functions';
import Table from '../../../table/Table';

const WashClubUsage = ({ ...props }) => {
    const tableConfig = {
        getData: QuestRoute.reports.washClubUsage,
        headers: [
            {
                label: 'Customer',
                propKey: 'customerName',
                options: true,
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Club',
                propKey: 'clubName',
                options: true,
            }, {
                label: 'Billing Day',
                propKey: 'billingDay',
            }, {
                label: 'Last Billed',
                propKey: 'lastBillingDate',
            }, {
                label: 'App Uses',
                propKey: 'usagesSinceLastBilling',
            }, 
            {
                label: 'Timer Uses',
                propKey: 'timeUsagesSinceLastBilling',
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.customerName}</td>
                <td>{e.email}</td>
                <td>{e.clubName}</td>
                <td>{e.billingDay}</td>
                <td>{shortHandDate(e.lastBillingDate)}</td>
                <td>{e.usagesSinceLastBilling}</td>
                <td>{e.timeUsagesSinceLastBilling}</td>
            </tr>
        ),
    }

    return (
        <Table config={tableConfig} />
    );
}

export default WashClubUsage;
